import { downloadFile } from './fileUtils';

function isIOS() {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
  );
}

function readPdfUrl(data) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Unable to read ticket PDF'));
    reader.readAsDataURL(new Blob([data], { type: 'application/pdf' }));
  });
}

export async function downloadTicketPdf(loadPdf, filename) {
  const ios = isIOS();
  const preview = ios ? window.open('', '_blank') : null;

  try {
    if (preview) {
      preview.opener = null;
      preview.document.title = filename;
    }

    const data = await loadPdf();
    if (!ios) {
      downloadFile(data, 'application/pdf', filename);
      return null;
    }

    const url = await readPdfUrl(data);
    if (preview && !preview.closed) {
      preview.location.href = url;
      return null;
    }

    return { url, filename };
  } catch (error) {
    if (preview && !preview.closed) preview.close();
    throw error;
  }
}
